import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "item", "group", "count", "statusFilter"]
  static values = {
    status: { type: String, default: "all" },
    refreshUrl: String
  }

  connect() {
    this.updateCount()
  }

  search() {
    this.filter()
  }

  filterByStatus(event) {
    this.statusValue = event.currentTarget.dataset.status
    this.highlightActiveFilter()
    this.filter()
  }

  highlightActiveFilter() {
    this.statusFilterTargets.forEach(btn => {
      if (btn.dataset.status === this.statusValue) {
        btn.classList.remove("bg-gray-100", "text-gray-600")
        btn.classList.add("bg-indigo-100", "text-indigo-700", "ring-1", "ring-indigo-300")
      } else {
        btn.classList.remove("bg-indigo-100", "text-indigo-700", "ring-1", "ring-indigo-300")
        btn.classList.add("bg-gray-100", "text-gray-600")
      }
    })
  }

  filter() {
    const query = (this.searchTarget.value || "").toLowerCase()
    const statusFilter = this.statusValue

    let visible = 0

    this.itemTargets.forEach(item => {
      const text = item.dataset.searchText.toLowerCase()
      const status = item.dataset.status
      const matchesSearch = !query || text.includes(query)
      const matchesStatus = statusFilter === "all" || status === statusFilter

      if (matchesSearch && matchesStatus) {
        item.classList.remove("hidden")
        visible++
      } else {
        item.classList.add("hidden")
      }
    })

    this.groupTargets.forEach(group => {
      const status = group.dataset.groupStatus
      const hasVisible = this.itemTargets.some(
        item => item.dataset.status === status && !item.classList.contains("hidden")
      )
      group.classList.toggle("hidden", !hasVisible)
    })

    this.updateCount(visible)
  }

  selectAll() {
    this.checkVisible(true)
  }

  selectAllActive() {
    this.visibleItems()
      .filter(item => item.dataset.status === "active")
      .forEach(item => {
        const cb = item.querySelector("input[type='checkbox']")
        if (cb && !cb.disabled) cb.checked = true
      })
  }

  deselectAll() {
    this.checkVisible(false)
  }

  checkVisible(checked) {
    this.visibleItems().forEach(item => {
      const cb = item.querySelector("input[type='checkbox']")
      if (cb && !cb.disabled) cb.checked = checked
    })
  }

  updateCount(visible) {
    if (!this.hasCountTarget) return
    const total = this.itemTargets.length
    if (visible === undefined) visible = total
    this.countTarget.textContent = visible === total
      ? `${total} campaigns`
      : `${visible} of ${total} campaigns`
  }

  refresh() {
    const frame = this.element.closest("turbo-frame")
    if (frame && this.hasRefreshUrlValue) {
      this.element.innerHTML = `
        <div class="border border-gray-200 rounded-lg bg-gray-50 p-6 text-center text-sm text-gray-400">
          <svg class="animate-spin h-5 w-5 mx-auto mb-2 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Refreshing campaigns from LinkedIn...
        </div>
      `
      frame.src = this.refreshUrlValue
    }
  }

  visibleItems() {
    return this.itemTargets.filter(item => !item.classList.contains("hidden"))
  }
}
